/**
 * Enum for tri-state values.
 * @readonly
 * @enum {string}
 */
enum ChaptersEnum {
  Authorize = "authorize",
  Bell = "bell",
  Closed = "closed",
  Contact = "contact",
  Fail = "fail",
  Filters = "filters",
  FiltersLocalisation = "filters_localisation",
  Header = "header",
  Help = "help",
  Home = "home",
  InProgress = "in_progress",
  Login = "login",
  MyAccount = "my_account",
  Offer = "offer",
  Onboarding = "onboarding",
  Registration = "registration",
  Requests = "requests",
  RequestCancel = "request_cancel",
  RequestDetail = "request_detail",
  RequestPreviousProposals = "request_previous_proposals",
  RequestProposals = "request_proposals",
  RequestRecommendations = "request_recommendations",
  RequestRecommendationDetail = "request_recommendation_detail",
  RequestRejectProposal = "request_reject_proposal",
  RequestUpdate = "request_update",
  ResetPassword = "reset_password",
  ResetPasswordConfirmation = "reset_password_confirmation",
  Success = "success",
}

export default ChaptersEnum;
